import { LOTTO_INSTANT } from "../lotto/instant-lotto"

export const ABOUT_NAME = 'abouts'

export const ABOUT_LIST_SKIN = {
    NAV: 'nav',
    DETAIL: 'detail'
}

interface gameSlug {
    NAP: string
    PERM: string
    BANKER1: string
    BANKER2: string
    LUCKY: string
    INSTANT: string
}
export const ABOUT_GAME_SLUG: gameSlug = {
    NAP: 'nap',
    PERM: 'perm',
    BANKER1: 'banker1',
    BANKER2: 'banker2',
    LUCKY: 'lucky',
    INSTANT: LOTTO_INSTANT.SLUG_GAME
}
